import 'semantic-ui-css/semantic.min.css'
import Page from './Page';

function App() {
	return <Page/>;
}

export default App;
